export default __webpack_public_path__ + "static/media/cord.1474e73f.jpg";